<div class="no-data-found" [attr.data-test-id]="testId()">
    <i class="no-data-found__icon" [class]="icon()"></i>
    <p class="no-data-found__text">{{ message() | translate }}</p>
</div>
